@if (isFetching) {
  <div class="hotel-card" [class.hotel-card--sm]="isSmallCard" [class.hotel-card--default]="isDefaultCard">
    <div class="hotel-card__header">
      <figure>
        <ngx-skeleton-loader [theme]="{height: '100%', width: '100%'}"></ngx-skeleton-loader>
      </figure>
      <div class="hotel-card__score">
        ‎
      </div>

      <button class="hotel-card__favourite btn-hurt btn-hurt--circle">
        <mat-icon [svgIcon]="eSvgIcons.HURT"></mat-icon>
      </button>
    </div>
    <div class="hotel-card__content">
      <h3 #titleRef>
        ‎<ngx-skeleton-loader [theme]="{height: titleRef.clientHeight + 'px', width: '70%'}"></ngx-skeleton-loader>
      </h3>

      <div class="hotel-card__starts">
        @for (start of 5 | generateStarData; track $index) {
          <mat-icon [svgIcon]="eSvgIcons.HOTEL_STAR"></mat-icon>
        }
      </div>

      <div class="hotel-card__info">
        <div class="hotel-card__advantages">
          <div class="hotel-card__row">
            <div class="hotel-card__with-icon">
              <mat-icon [svgIcon]="eSvgIcons.BREAKFAST"></mat-icon>
              ‎<ngx-skeleton-loader [theme]="{height: titleRef.clientHeight + 'px', width: '70%'}"></ngx-skeleton-loader>
            </div>
          </div>
        </div>

        <div class="hotel-card__price">
          <p class="hotel-card__price--payment">&#8364;0</p>
        </div>
      </div>
    </div>
    <div class="hotel-card__footer">
      <button class="hotel-card__read-more btn-default btn-blue">
        See availability
      </button>
    </div>
    <div class=" hotel-card__logo">
      <mat-icon [svgIcon]="eSvgIcons.BOOKING"></mat-icon>
    </div>
  </div>
} @else {
  @if (hotel) {
    <div class="hotel-card" [class.hotel-card--sm]="isSmallCard" [class.hotel-card--default]="isDefaultCard">
      <div class="hotel-card__header">
        <figure>
          <img [src]="hotel?.image?.ThumbnailUrl | safeUrl" alt="country-image">
        </figure>
        <div class="hotel-card__score">
          {{ hotel.rating.average }}
        </div>

        <div class="hotel-card__favourite btn-hurt btn-hurt--circle"
             [class.active]="favoritesProviderService.isFavorite('booking.com', hotel.id)"
             (click)="toggleHurt($event, hotel)">
          <mat-icon [svgIcon]="eSvgIcons.HURT"></mat-icon>
        </div>
      </div>
      <div class="hotel-card__content">
        <h3>{{ hotel.name }}</h3>

        <div class="hotel-card__starts">
          @for (start of hotel.stars | generateStarData; track $index) {
            <mat-icon [svgIcon]="eSvgIcons.HOTEL_STAR"></mat-icon>
          }
        </div>

        <div class="hotel-card__info">
          <div class="hotel-card__advantages">
            @if (hotel.mealPlan === "breakfast_included") {
              <div class="hotel-card__row">
                <div class="hotel-card__with-icon">
                  <mat-icon [svgIcon]="eSvgIcons.BREAKFAST"></mat-icon>
                  <p>Breakfast included</p>
                </div>
              </div>
            }

            @if (hotel.cancellation | hotelCancellationTransformer) {
              <div class="hotel-card__row">
                <div class="hotel-card__with-icon">
                  <mat-icon [svgIcon]="eSvgIcons.FREE_CANCELLATION"></mat-icon>
                  <p>Free cancellation</p>
                </div>
              </div>
            }
          </div>

          <div class="hotel-card__price">
            @if (hotel.price) {
              <p class="hotel-card__price--payment">{{ hotel.price.currency === "EUR" ? "&#8364;" : "&#36;" }}{{ hotel.price | hotelPriceTransformer }}</p>
            }
          </div>
        </div>
      </div>
      <div class="hotel-card__footer">
        <a class="hotel-card__read-more btn-default btn-blue"
           (click)="setGoogleAnalytic()"
           target="_blank"
           href="{{hotel.providerURL || hotel.url}}"
        >
          See availability
        </a>
      </div>
      <div class="hotel-card__logo">
        <mat-icon [svgIcon]="eSvgIcons.BOOKING"></mat-icon>
      </div>
    </div>
  }
}
